import { Deserializable } from '../protocols/deserializable';
import { RetirementProductSubmissionAvailability } from './retirement-product-submission-availability';

export class MpRetirementProductSubmissionAvailability implements Deserializable {
  public variableBenefitPaymentChange!: RetirementProductSubmissionAvailability;

  public onDeserialize(): void {
    this.variableBenefitPaymentChange = window?.injector?.Deserialize?.instanceOf(
      RetirementProductSubmissionAvailability,
      this.variableBenefitPaymentChange
    );
  }
}
